<template>
  <button @click="removeCar" class="remove-car-btn">
    <img :src="RemoveCompareTile" alt="An icon of a cross." width="10" />
  </button>
</template>

<script setup lang="ts">
import RemoveCompareTile from '../../assets/img/remove-compare-tile.svg';
import { useCarComparisonStore } from '../../foundation/stores/carComparisonStore';

const props = defineProps({
  index: {
    type: Number,
    required: true,
  },
  showFooter: {
    type: Boolean,
    default: false,
  },
  vehicleId: {
    type: String,
    required: false,
  },
});

const comparisonStore = useCarComparisonStore();

function removeCar() {
  comparisonStore.removeCarToCompare(props.index, props.showFooter);
}
</script>

<style lang="scss" scoped>
.remove-car-btn {
  background: $racq-true-white;
  border: none;
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
  position: absolute;
  top: 0.4rem;
  right: 0.4rem;

  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background: darken($racq-true-white, 5%);
    border: 1px solid $racq-light-grey;
  }
}
</style>
